// /features: the public Features page (handoff Features.dc.html; W4-4).
// Rendered inside the public site's frame (routes/_site.tsx) and split into
// its own chunk, so it never loads the signed-in app. Open to everyone,
// signed in or not: a chef reading it keeps the header's "Go to dashboard".
import { createFileRoute } from '@tanstack/react-router';
import { FeaturesPage } from '@/features/site/features/FeaturesPage';

export const Route = createFileRoute('/_site/features')({
  component: FeaturesPage,
});
